/** Pure formatting helpers for the hero data-age counter. Kept dependency-free and testable. */

export type AgeState = "fresh" | "aging" | "stale";

/** green < 60s, amber < 180s, red beyond. */
export function ageState(ageSec: number): AgeState {
  if (ageSec < 60) return "fresh";
  if (ageSec < 180) return "aging";
  return "stale";
}

export function formatMMSS(totalSec: number): string {
  const s = Math.max(0, Math.floor(totalSec));
  const mm = Math.floor(s / 60);
  const ss = s % 60;
  return `${String(mm).padStart(2, "0")}:${String(ss).padStart(2, "0")}`;
}

export function formatLatencySec(latencyMs: number): string {
  return `${(latencyMs / 1000).toFixed(1)}s`;
}
